import {
    getApiBarberProfileQueryKey,
    getApiBarberShiftsAvailableSlotsQueryKey,
    getApiBarberShiftsBookedQueryKey,
    usePostApiBarberShiftCancel,
} from '@barbershop/api/barber'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { FORMATTED_TODAY_DATE, FORMATTED_TOMORROW_DATE } from '../../model/constants'

const bookedShiftsBaseQueryKey = getApiBarberShiftsBookedQueryKey({ from: '', to: '' }).slice(0, 1)

export const useCancelBookedShift = () => {
    const queryClient = useQueryClient()

    const { mutateAsync: cancelBookedShift, isPending } = usePostApiBarberShiftCancel({
        mutation: {
            onSuccess: async () => {
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberProfileQueryKey(),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getApiBarberShiftsAvailableSlotsQueryKey({
                            from: FORMATTED_TODAY_DATE,
                            to: FORMATTED_TOMORROW_DATE,
                        }),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: bookedShiftsBaseQueryKey,
                    }),
                ])
                toast.success('Смена успешно отменена')
            },
            onError: () => {
                toast.error('Ошибка при отмене смены')
            },
        },
    })

    return {
        cancelBookedShift,
        isPending,
    }
}
